export type ArchetypeId =
  | 'paper-strong-person-weak'
  | 'smart-but-unstructured'
  | 'mature-board-ready'
  | 'developing-balanced'
  | 'at-foundation';

/**
 * Map two axis scores (0-100) to an archetype. Total by construction — every
 * board lands in exactly one bucket, so there are no "dead zones" where a
 * struggling board gets no tailored copy.
 *
 * Order matters:
 *  1. Both genuinely strong            -> mature-board-ready
 *  2. One axis clearly ahead (>=10pts) -> the lean archetypes, named for the
 *                                         lagging axis the board should lift
 *  3. Competent on both, not yet ready -> developing-balanced
 *  4. Anything else                    -> at-foundation
 *
 * `lowConfidence` (set when an axis was scored off too few answers — i.e. a
 * coverage flag fired) suppresses the top "mature-board-ready" claim so a board
 * that skipped most questions is never certified board-ready off thin data.
 */
export function matchArchetype(
  axes: { gov: number; cap: number },
  opts?: { lowConfidence?: boolean },
): ArchetypeId {
  const { gov, cap } = axes;
  const gap = gov - cap;

  if (gov >= 70 && cap >= 70 && !opts?.lowConfidence) return 'mature-board-ready';
  if (gov >= 60 && gap >= 10) return 'paper-strong-person-weak';
  if (cap >= 60 && gap <= -10) return 'smart-but-unstructured';
  if (gov >= 50 && cap >= 50) return 'developing-balanced';
  return 'at-foundation';
}
